// @flow
import SwipeContainer from "./SwipeContainer";

export default SwipeContainer;

export { Swipe } from "./Swipe";
